import { render, staticRenderFns } from "./appNav.vue?vue&type=template&id=848278c8&scoped=true"
import script from "./appNav.js?vue&type=script&lang=js&external"
export * from "./appNav.js?vue&type=script&lang=js&external"
import style0 from "./appNav.vue?vue&type=style&index=0&id=848278c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848278c8",
  null
  
)

export default component.exports